import {
  faFacebookF,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import Download_now from "../home/download_now/Download_now";
import "./Footer.css";

const Footer = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [pathname]);

  return (
    <>
      <Download_now />

      <footer className="footer">
        <Container>
          <div className="footer-top align-items-center">
            <Row>
              <Col lg={2} md={12}>
                <div className="footer-logo-section">
                  <div className="footer-logo">
                    <Link to={"/"}>
                      <img
                        src="/assets/images/header/logo.png"
                        alt="Origin Logo"
                        className="logo-image"
                      />
                    </Link>
                  </div>
                </div>
              </Col>

              <Col lg={10} md={12}>
                <div className="footer-links-section">
                  <div className="row">
                    <div className="col-md-2 col-sm-4">
                      <div className="footer-links">
                        <Link to="/" className="footer-link">
                          Home
                        </Link>
                      </div>
                      <div className="footer-links">
                        <Link to="/services" className="footer-link">
                          Services
                        </Link>
                      </div>
                    </div>

                    <div className="col-md-2 col-sm-4">
                      <div className="footer-links">
                        <Link to="/refer-and-earn" className="footer-link">
                          Refer & Earn
                        </Link>
                      </div>
                      <div className="footer-links">
                        <Link to="/contact-us" className="footer-link">
                          Contact Us
                        </Link>
                      </div>
                    </div>

                    <div className="col-md-3 col-sm-4">
                      <div className="footer-links">
                        <Link to="/terms-and-condition" className="footer-link">
                          Terms And Conditions
                        </Link>
                      </div>
                      <div className="footer-links">
                        <Link to="/privacy-policy" className="footer-link">
                          Privacy Policy
                        </Link>
                      </div>
                    </div>

                    <div className="col-md-5">
                      <div className="footer-contact-section">
                        <div className="footer-contact">
                          <div className="contact-item">
                            <div className="contact-icon email-icon">
                              <FontAwesomeIcon icon={faEnvelope} />
                            </div>
                            <span>info@aiorigin.com</span>
                          </div>
                          <div className="contact-item">
                            <div className="contact-icon phone-icon">
                              <FontAwesomeIcon icon={faPhone} />
                            </div>
                            <span>+91 6757732412</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="footer-divider"></div>

                <Row className="footer-bottom align-items-center">
                  <Col md={6} className="footer-social-section">
                    <span className="follow-text">Follow us on:</span>
                    <div className="social-icons">
                      <Link
                        to="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                      >
                        <FontAwesomeIcon icon={faFacebookF} />
                      </Link>

                      <Link
                        to="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                      >
                        <FontAwesomeIcon icon={faInstagram} />
                      </Link>

                      <Link
                        to="https://youtube.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                      >
                        <FontAwesomeIcon icon={faYoutube} />
                      </Link>
                    </div>
                  </Col>

                  <Col md={6} className="footer-copyright-section">
                    <p className="copyright-text">
                      © 2025. All Rights Reserved. Developed by{" "}
                      <a
                        href="https://profcymaglobal.profcyma.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        Profcyma{" "}
                      </a>{" "}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
